import React from "react";
import { RedWave } from "@/components/RedWave";

const FOCUS_IMG =
  "https://images.unsplash.com/photo-1552975955-b7a92c9aa248?w=1600&q=85&auto=format&fit=crop";

export default function WhyDifferent() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1 relative">
          <div className="relative aspect-[4/5] overflow-hidden rounded-[2px] border border-[color:var(--fs-hairline)]">
            <img
              src={FOCUS_IMG}
              alt="Espresso machine brewing dark coffee into two glasses in a moody cafe"
              className="w-full h-full object-cover"
              data-testid="why-image"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/80 via-black/20 to-transparent" />
            <div className="absolute top-6 left-6 right-6 flex items-center gap-3">
              <span className="h-[1px] w-8 bg-[color:var(--fs-gold-muted)]" />
              <span className="text-[10px] tracking-[0.32em] uppercase text-[color:var(--fs-gold-muted)]">
                The Outcome
              </span>
            </div>
          </div>
          <div className="absolute -bottom-6 left-[10%] right-[10%] h-12 opacity-90">
            <RedWave className="w-full h-full" strokeWidth={1.5} />
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <span className="text-[10px] tracking-[0.32em] uppercase text-[color:var(--fs-gold-muted)]">
            04 / Why It Feels Different
          </span>
          <h2
            className="mt-5 font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-white"
            data-testid="why-heading"
          >
            Engineered for a<br />
            <span className="italic text-gold-foil">Better Experience.</span>
          </h2>

          <div className="mt-10 space-y-6 max-w-xl">
            <p className="text-neutral-300 text-base md:text-lg leading-relaxed">
              A refined blend designed to smooth out the highs and eliminate the
              crash — so you get clean, focused energy that lasts.
            </p>
            <p className="text-neutral-500 text-sm md:text-base leading-relaxed">
              Enhanced with carefully selected natural compounds traditionally
              used to support focus and balance. You won't taste them. You'll
              feel them.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-4 max-w-md">
            {[
              "Clean stimulation",
              "Balanced energy",
              "No-crash formula",
            ].map((x) => (
              <div
                key={x}
                className="border border-[color:var(--fs-hairline)] px-3 py-3 rounded-full text-center text-[10px] tracking-[0.18em] uppercase text-[color:var(--fs-gold-muted)]"
                data-testid={`why-pill-${x.replace(/\s+/g, "-").toLowerCase()}`}
              >
                {x}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
